var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttempt1Badge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 18,
    rx: 7.5,
    stroke: "#3260D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86 14C8.716 14 8.604 13.964 8.524 13.892C8.444 13.812 8.404 13.704 8.404 13.568C8.404 13.432 8.444 13.332 8.524 13.268C8.604 13.196 8.716 13.16 8.86 13.16H10.42V6.356H10.936L9.196 7.508C9.092 7.564 8.992 7.588 8.896 7.58C8.808 7.572 8.732 7.54 8.668 7.484C8.612 7.42 8.572 7.348 8.548 7.268C8.524 7.18 8.528 7.092 8.56 7.004C8.592 6.908 8.66 6.828 8.764 6.764L10.42 5.672C10.524 5.608 10.624 5.556 10.72 5.516C10.816 5.476 10.912 5.456 11.008 5.456C11.12 5.456 11.212 5.492 11.284 5.564C11.364 5.628 11.404 5.732 11.404 5.876V13.16H12.844C12.988 13.16 13.1 13.196 13.18 13.268C13.26 13.332 13.3 13.432 13.3 13.568C13.3 13.712 13.26 13.82 13.18 13.892C13.1 13.964 12.988 14 12.844 14H8.86Z",
    fill: "#3260D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempt1Badge);
export default __webpack_public_path__ + "static/media/attempt-1-badge.4e1cb1c4e4b23295776835d295e6ab49.svg";
export { ForwardRef as ReactComponent };